<span #ellipsesspan>
    <!-- {{this.i}} -->
    <!-- <span *ngFor="let number of numbers">.</span> -->
    <span [ngStyle]="{'visibility': (this.i > 0 ? 'unset' : 'hidden')}">.</span><span [ngStyle]="{'visibility': (this.i > 1 ? 'unset' : 'hidden')}">.</span><span [ngStyle]="{'visibility': (this.i > 2 ? 'unset' : 'hidden')}">.</span>
    <!-- <span>.</span>
    <span>.</span>
    <span>.</span> -->
</span>
